<template>
  <div class="search-popup-box">
    <van-sticky>
        <!--搜索框 -->
      <van-search
        shape="round"
        v-model="value"
        show-action
        :placeholder="placeholderVal"
        @search="onSearch"
        @cancel="onCancel"
      >
      <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    

    <!-- 历史记录和热门搜索 组件 -->
    <!-- 接受子组件传来的数据 -->
    <HistoryHot
      v-if="blockShow == 1"
      :historyKeywordList="historyKeywordList"
      :hotKeywordList="hotKeywordList"
      @goSearch="setValue"
    ></HistoryHot>

    <!-- 搜索提示 组件 -->
    <!-- <SearchTipsList
      v-else-if="blockShow == 2"
      :dataList="dataList"
      @setValue="setValue"
    ></SearchTipsList> -->
    <div v-else class="cate__body"  @scroll="handleScroll">

      <div class="prod-items"
        v-for="item in goodsList"
        :key="item.id"
        @click="gotodetail(item.prodId)">
        <div class="hot-imagecont">
          <img :src="item.pic" class="hotsaleimg" />
        </div>
        <div class="hot-span">
          <div class="hotprod-span">{{ item.prodName }}</div>
          <div class="'prod-span-info'">
            <div class="price">
              <img v-if="currentActivityId == 13" src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" alt="积分" style="width: 16px; height: 16px; margin-right: 4px;"/>
              <span v-if="currentActivityId != 13" class="symbol">￥</span>
              <span class="big-num">{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="loading-wrapper">
        <img src="https://img.zhujiaxian.com/2025/05/21f52dbb86f247098f3b3add676a775b.gif" alt="加载中" class="loading-gif">
      </div>
      
      <div v-if="!loading && noMoreProducts && goodsList.length > 0" style="text-align: center; padding: 20px; color: #999;">
        已无更多产品
      </div>
      
      <div v-if="!loading && goodsList.length == 0" style="text-align: center;font-size: 15px;">
        <div style="padding-top:50px;margin: 0 auto;">
          <img style="width:184px;height: 113px;" src="https://img.zhujiaxian.com/2024/03/fc059c5166e84a34a9ceae18427a0ac8.png" alt="">
        </div>
          <div>
            <span>抱歉！没有找到你想要的</span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import HistoryHot from "@/views/search/HistoryHot";
// import searchProducts from "@/views/search/searchProducts";
// import SearchTipsList from "@/views/search/SearchTipsList";
// 引入请求接口
import {
  GetSearchData,
  GetPopupData,
  GetSearchTipsListData,
} from "@/https/http";
// 引入URL参数处理工具
// import { getActivityIdFromRoute } from "@/utils/urlUtil";
export default {
  name: "search-popup",
  data() {
    return {
      value: "", // 搜索值
      page: 1, //页数
      current:1,
      size: 20, // 每页数据条数
      order: 0, // 价格由高到底
      categoryId: null, // 商品类别id 全家、居家、餐饮。。。
      sort: 0, // 排序字段 price 和id  2种情况
      goodsList: [], // 搜索出来的商品数据
      filterCategory: [], // 商品类别参数
      historyKeywordList: [], //历史记录数据
      hotKeywordList: [], // 热门搜索 数据
      blockShow: 1, //控制显示哪个？（ 历史记录和热门搜索组件 、 搜索提示组件、下拉菜单组件）
      dataList: [], //搜索提示数据
      placeholderVal: "", // 搜索框的默认提示词
      result: {
        size: 10,
        sort: 0,
        pages: 0,
        current: 1,
        prodName:'',
        orderBy: 0
      },
      taglist: [], // 用于存储已加载的商品数据，实现分页加载
      loading: false, // 加载中状态
      noMoreProducts: false, // 是否没有更多产品了
    };
  },
  methods: {
    gotodetail(id_) {
      this.$router.push({ path: "/productDetail", query: { id: id_ } });
    },
    priceChange1(value) {
      // value为子组件searchProducts传来的价格排序参数asc，desc
      console.log("父组件：价格", value);
      this.order = value;
      this.sort = "price";
      this.onSearch();
      //   this.$router.go(0);
    },

    categoryChange1(value) {
      // value为子组件searchProducts传来的种类参数
      console.log("父组件：类别id", value);
      this.sort = "id";
      this.categoryId = value;
      this.onSearch();
    },

    // 搜索框搜索功能
    onSearch() {
      this.blockShow = 3;
      this.result.prodName = this.value
      // 关键字搜索接口数据
      //   发送数据请求
      // 搜索框商品搜索功能接口，获取对应的商品列表
      this.loading = true; // 设置加载中状态
      
      GetSearchData(this.result).then((res) => {
        console.log(22, res);

        // this.filterCategory = res.data.records;
        // // 将商品的类别中的字段替换一下
        // this.filterCategory = JSON.parse(
        //     JSON.stringify(this.filterCategory)
        //         .replace(/id/g, "value")
        //         .replace(/name/g, "text")
        // );
        let list = [];
        // let lists = [];
        if (res.data.current == 1) {
          res.data.records.forEach((element) => {
            console.log(element);
            // if (element.top == null || element.top == 0) {
            //   list.push(element);
            // } else {
            //   lists.push(element);
            // }
             list.push(element);
          });
          // this.subCategoryList = lists;
        } else {
          list = this.goodsList.concat(res.data.records);
        }
        this.goodsList = list;
        this.taglist = list; // 保存已加载的所有商品数据
        this.result.pages = res.data.pages;
        
        // 判断是否已经加载了所有页面
        if (this.result.current >= this.result.pages) {
          this.noMoreProducts = true;
        }
        
        this.loading = false; // 取消加载中状态
      }).catch(() => {
        this.loading = false; // 出错时也要取消加载中状态
      });
    },
    handleScroll(event) {
      console.log(event,111);
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      // 设置一个小的阈值(20px)，当滚动条接近底部时就触发加载，提高用户体验
      const threshold = 20;
      // 当滚动条接近底部时，且没有在加载中，且还有更多产品
      if (scrollTop + clientHeight >= scrollHeight - threshold && !this.loading && !this.noMoreProducts) {
        console.log("接近底部，触发加载更多");
        this.result.current++;
        this.onSearch();
      }
    },
    // 搜索取消
    onCancel() {
      console.log("取消");
      this.$router.push("/home");
    },

    // 获得历史记录
    gethistoryHotData() {
      GetPopupData().then((res) => {
        console.log(555, res);
        // this.historyKeywordList = res.data.historyKeywordList;
        // this.hotKeywordList = res.data;
        let data = [
          {
            content: "牛奶",
            hotSearchId: 1,
            title: "牛奶"
          },
          {
            content: "红枣",
            hotSearchId: 2,
            title: "红枣"
          },
          {
            content: "驻家鲜",
            hotSearchId: 3,
            title: "驻家鲜"
          },
          {
            content: "金龙鱼",
            hotSearchId: 4,
            title: "金龙鱼"
          }
      ]
      this.hotKeywordList = data;
        // this.placeholderVal = res.data.defaultKeyword.keyword;
      });
    },

    // 获取搜索提示
    // getSearchHelperData(value) {
    //     this.blockShow = 2   // 展示搜索提示列表组件
    //     // 输入触发
    //     // 搜索提示数据请求
    //     GetSearchTipsListData({ keyword: value }).then((res) => {
    //         console.log(333333, res);
    //         this.dataList = res.data
    //     })
    // },
    setValue(m) {
      console.log(6666, m);
      this.value=m;
      //this.result.prodName = m;
      this.onSearch();
    },
    // onInput(value) {
    //     this.getSearchHelperData(value)
    // }
  },
  computed: {
    // 从全局状态获取活动ID
    // globalActivityId() {
    //   return this.$store.getters.getActivityId;
    // },
    // // 获取当前使用的活动ID，优先使用URL中的，然后是全局状态中的
    // currentActivityId() {
    //   const urlActivityId = getActivityIdFromRoute(this.$route);
    //   return urlActivityId || this.globalActivityId;
    // }
  },
  created() {
    // 优先从全局状态获取活动ID，如果没有则从路由获取
    // if (this.globalActivityId) {
    //   this.result.h5 = this.globalActivityId;
    // } else {
    //   const activityId = getActivityIdFromRoute(this.$route);
    //   if (activityId) {
    //     this.result.h5 = activityId;
    //     // 将活动ID保存到全局状态中
    //     this.$store.dispatch('updateActivityId', activityId);
    //   }
    // }
    this.gethistoryHotData();
  },
  components: {
    HistoryHot,
    // searchProducts,
    // SearchTipsList,
  },
};
</script>

<style>
.prod-items {
  width: 172.5px;
  display: inline-block;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.hot-imagecont .hotsaleimg {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.hot-span .hotprod-span {
  height: 38px;
  line-height: 19px;
  font-size: 14px;
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #000;
}

.prod-items .hot-imagecont {
  text-align: center;
  font-size: 0;
  width: 152px;
  height: 152px;
}

.prod-items .hot-span {
  margin-top: 10px;
}

.prod-items .hot-span .prod-info {
  font-size: 10px;
  color: #777;
  margin-top: 4px;
  margin-left: 8px;
}

.prod-items .hot-span .prod-span-info {
  position: relative;
  height: 20px;
  line-height: 20px;
  font-family: Arial;
  margin-top: 10px;
}
.collection-row {
  display: flex;
  justify-content: space-between;
}

.price {
  color: #e43130;
}
.deadline-price {
  font-size: 11px;
  margin-right: 2.5px;
}

.basket-img {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  bottom: 3px;
  padding: 4px;
}
.symbol {
  font-size: 12px;
}
.big-num {
  font-size: 16px;
}
.search-popup-box {
  height: 100vh;
  overflow: hidden;
}

  .cate__body{
  height: calc(100vh - 50px); /* 减去搜索框的高度 */
  overflow-y: auto; /* 开启滚动 */
  -webkit-overflow-scrolling: touch; /* 启用iOS上的回弹滚动效果 */
}

.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.loading-gif {
  width: 40px;
  height: 40px;
}
</style>
